import React from 'react';
import { Group } from 'react-konva';
import WithCursorPointer from 'components/canvas/components/with-pointer-cursor';
import ContextMenuButton from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/components/context-menu-button';
import ContextBar from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/components/context-bar';
import useNodeContextMenuVisibility from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/hooks/use-node-context-menu-visibility';
import useNodeContextMenuIcons, {
  IconsProps,
} from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/hooks/use-node-context-icons';
import { useSetHighestZIndexToNode } from 'components/canvas/hooks/use-set-heighest-z-index-to-node';
import { useNodeContextMenuAnimation } from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/hooks/use-node-context-menu-animation';
import { SurfaceNodeUnion } from 'graphql/types';
import { notEmpty } from 'utils';
import { useRiskMenuPosition } from 'state/canvas/selected-risk';

export interface NodeContextMenuProps {
  width: number;
  height: number;
  node: SurfaceNodeUnion;
  isVisible?: boolean;
  softDelete?: boolean;
  onAfterDelete?: Function;
  prePendIcons?: React.ReactElement[];
  hardDelete?: boolean;
  icons?(props: IconsProps): React.ReactElement[] | null;
  onRiskClick?: Function;
}

const defaultProps = {};

function NodeContextMenu(props: NodeContextMenuProps) {
  const setHighestZIndexToNode = useSetHighestZIndexToNode();

  const elementRef = useNodeContextMenuAnimation(props.node);

  const { isVisible, toggleVisibility } = useNodeContextMenuVisibility(
    props.node,
  );
  const [riskPos, setRiskMenuPosition] = useRiskMenuPosition();

  const Icons = useNodeContextMenuIcons(props);
  const groupId = 'context-menu-' + props.node.id;

  function showMenu(event) {
    event.cancelBubble = true;
    //setHighestZIndexToNode(props.node);
    toggleVisibility(event);
    // setRiskMenuPosition(null);
  }
  // console.log('CLEAR Selected node ', isVisible, props.node);
  return React.useMemo(() => {
    if (notEmpty(Icons)) {
      return (
        <WithCursorPointer>
          <Group ref={elementRef} id={groupId} x={props.width}>
            {isVisible && <ContextBar icons={Icons} />}
            <ContextMenuButton onClick={showMenu} />
          </Group>
        </WithCursorPointer>
      );
    }

    return null;
  }, [props.width, isVisible]);
}

NodeContextMenu.defaultProps = defaultProps;

export default NodeContextMenu;
